import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import TopBar from '../components/layout/TopBar.svelte';
import Card from '../components/shared/Card.svelte';
import Button from '../components/shared/Button.svelte';
import InvitePartner from '../components/sync/InvitePartner.svelte';
import HandoffNote from '../components/sync/HandoffNote.svelte';
import { getSyncStatus } from '../lib/stores/sync.svelte.ts';
import { showToast } from '../components/shared/Toast.svelte';

var root_1 = $.from_html(`<div class="sync-info svelte-1pl82tsit5qge"><h3 class="svelte-1pl82tsit5qge">Cloud Sync <span class="coming-soon-badge svelte-1pl82tsit5qge">Coming Soon</span></h3> <p class="hint svelte-1pl82tsit5qge">Sync your data to the cloud and share with your partner. All data stays local until you enable sync.</p> <div class="field svelte-1pl82tsit5qge"><label class="svelte-1pl82tsit5qge">Email</label> <input type="email" placeholder="you@example.com" disabled="" class="svelte-1pl82tsit5qge"/></div> <!></div>`);
var root_3 = $.from_html(`<div class="sync-info svelte-1pl82tsit5qge"><h3 class="svelte-1pl82tsit5qge">Join a Partner <span class="coming-soon-badge svelte-1pl82tsit5qge">Coming Soon</span></h3> <p class="hint svelte-1pl82tsit5qge">Enter the invite code your partner shared with you.</p> <input type="text" placeholder="Enter code" class="code-input svelte-1pl82tsit5qge" disabled=""/> <!></div>`);
var root = $.from_html(`<!> <div class="sync-page svelte-1pl82tsit5qge"><!> <!> <!> <!></div>`, 1);

function Sync($$anchor, $$props) {
	$.push($$props, true);

	const status = $.derived(getSyncStatus);
	let email = $.state('');
	let joinCode = $.state('');

	function handleSetup() {
		showToast('Cloud sync will be available soon', 'info');
	}

	var fragment = root();
	var node = $.first_child(fragment);

	TopBar(node, { title: 'Partner Sync', showBack: true, backPath: '/more' });

	var div = $.sibling(node, 2);
	var node_1 = $.child(div);

	Card(node_1, {
		padding: 'md',
		children: ($$anchor, $$slotProps) => {
			var div_1 = root_1();
			var div_2 = $.sibling($.child(div_1), 4);
			var input = $.sibling($.child(div_2), 2);

			$.remove_input_defaults(input);
			$.reset(div_2);

			var node_2 = $.sibling(div_2, 2);

			Button(node_2, {
				variant: 'primary',
				fullWidth: true,
				onclick: handleSetup,
				disabled: true,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text = $.text('Enable Cloud Sync');

					$.append($$anchor, text);
				},
				$$slots: { default: true }
			});

			$.reset(div_1);
			$.bind_value(input, () => $.get(email), ($$value) => $.set(email, $$value));
			$.append($$anchor, div_1);
		},
		$$slots: { default: true }
	});

	var node_3 = $.sibling(node_1, 2);

	Card(node_3, {
		padding: 'md',
		children: ($$anchor, $$slotProps) => {
			var div_3 = root_3();
			var input_1 = $.sibling($.child(div_3), 4);

			$.remove_input_defaults(input_1);

			var node_4 = $.sibling(input_1, 2);

			Button(node_4, {
				variant: 'secondary',
				fullWidth: true,
				onclick: handleSetup,
				disabled: true,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_1 = $.text('Join');

					$.append($$anchor, text_1);
				},
				$$slots: { default: true }
			});

			$.reset(div_3);
			$.bind_value(input_1, () => $.get(joinCode), ($$value) => $.set(joinCode, $$value));
			$.append($$anchor, div_3);
		},
		$$slots: { default: true }
	});

	var node_5 = $.sibling(node_3, 2);

	InvitePartner(node_5, {});

	var node_6 = $.sibling(node_5, 2);

	HandoffNote(node_6, {});
	$.reset(div);
	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	Sync = $.hmr(Sync);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-1pl82tsit5qge');
		Sync[$.HMR].update(module.default);
	});
}

export default Sync;
import "bun-svelte:Sync.svelte-wt2zuh5eqhky-style.css";